<a
  [routerLink]="['/admin', 'competition', competitionId]"
  type="button"
  class="btn btn-primary d-block"
  ><fa-icon [icon]="faEdit" title="Edit"></fa-icon
></a>
